
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/category/[id]",
      function () {
        return require("private-next-pages/blogs/category/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/category/[id]"])
      });
    }
  